import { NgModule } from '@angular/core';
import { SStatsCardPersonalProtectiveEquipmentComponent } from './s-stats-card-personal-protective-equipment.component';
import { CommonModule } from '@angular/common';
import { SStatsCardPersonalProtectiveEquipmentService } from './s-stats-card-personal-protective-equipment.service';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { LoadingStateModule, StatsCardModule } from '@seniorsistemas/angular-components';

@NgModule({
    imports: [
        CommonModule,
        StatsCardModule,
        HttpClientModule,
        SharedModule,
        LoadingStateModule
    ],
    declarations: [SStatsCardPersonalProtectiveEquipmentComponent],
    providers: [SStatsCardPersonalProtectiveEquipmentService],
    exports: [SStatsCardPersonalProtectiveEquipmentComponent]
})
export class SStatsCardPersonalProtectiveEquipmentModule { }
